import { render, staticRenderFns } from "./pub_tv.vue?vue&type=template&id=dbf543ac&scoped=true"
import script from "./pub_tv.vue?vue&type=script&lang=js"
export * from "./pub_tv.vue?vue&type=script&lang=js"
import style0 from "./pub_tv.vue?vue&type=style&index=0&id=dbf543ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf543ac",
  null
  
)

export default component.exports